import React, { useState } from "react";
import { getTeamAvatarColor, getTeamInitials } from "../lib/teamInitials";
import "./teamLogo.css";

/**
 * Renders API team badge or themed initials fallback (first + second name letters).
 */
export default function TeamLogo({
  teamName,
  logoUrl,
  className = "",
  alt,
  size = "md",
}) {
  const [imgFailed, setImgFailed] = useState(false);
  const initials = getTeamInitials(teamName);
  const bg = getTeamAvatarColor(teamName);
  const label = alt || teamName || "Team";
  const showImage =
    logoUrl && String(logoUrl).trim().length > 0 && !imgFailed;

  if (showImage) {
    return (
      <img
        src={logoUrl}
        alt={label}
        className={`team-logo team-logo--img team-logo--${size} ${className}`.trim()}
        loading="lazy"
        onError={() => setImgFailed(true)}
      />
    );
  }

  return (
    <span
      className={`team-logo team-logo--initials team-logo--${size} ${className}`.trim()}
      style={{ backgroundColor: bg }}
      title={label}
      aria-label={label}
    >
      {initials}
    </span>
  );
}
